import React, { Component, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import Yasgui from "@triply/yasgui";
import "@triply/yasgui/build/yasgui.min.css";

function SPARQLEditorModal(props) {

  useEffect(() =>  {
    localStorage.removeItem("yagui__config")

    let settings = {
      requestConfig: { endpoint: props.endpoint },
      copyEndpointOnNewTab: false
    }

    new Yasgui(document.getElementById("yasgui"), settings)
  })


  const handleSubmit = (event) => {
    event.preventDefault();
  }

  return (
    <Modal size="xl" show={props.show} onHide={props.onClose} animation={false} backdrop="static">
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>SPARQL editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id='yasgui'/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default SPARQLEditorModal;
